<script setup>
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import RadioCard from 'dashboard/components-next/radioCard/RadioCard.vue';
import Icon from 'dashboard/components-next/icon/Icon.vue';
import {
  getAppearance,
  setAppearance,
} from 'dashboard/composables/commands/useAppearanceHotKeys';

// Same three choices as the ⌘K "change appearance" command, as cards.
const { t } = useI18n();
const current = ref(getAppearance());

const options = computed(() => [
  {
    key: 'light',
    icon: 'i-lucide-sun',
    label: t('PROFILE_SETTINGS.FORM.APPEARANCE_SECTION.LIGHT'),
    description: t('PROFILE_SETTINGS.FORM.APPEARANCE_SECTION.LIGHT_NOTE'),
  },
  {
    key: 'dark',
    icon: 'i-lucide-moon',
    label: t('PROFILE_SETTINGS.FORM.APPEARANCE_SECTION.DARK'),
    description: t('PROFILE_SETTINGS.FORM.APPEARANCE_SECTION.DARK_NOTE'),
  },
  {
    key: 'auto',
    icon: 'i-lucide-monitor',
    label: t('PROFILE_SETTINGS.FORM.APPEARANCE_SECTION.AUTO'),
    description: t('PROFILE_SETTINGS.FORM.APPEARANCE_SECTION.AUTO_NOTE'),
  },
]);

const select = key => {
  setAppearance(key);
  current.value = key;
};
</script>

<template>
  <div class="flex flex-col justify-between w-full gap-5 sm:gap-4 sm:flex-row">
    <RadioCard
      v-for="option in options"
      :id="option.key"
      :key="option.key"
      :label="option.label"
      :description="option.description"
      :is-active="current === option.key"
      class="sm:flex-1"
      @select="select"
    >
      <div
        class="flex items-center justify-center w-full h-20 rounded-lg bg-n-slate-3 text-n-slate-11"
      >
        <Icon :icon="option.icon" class="size-8" />
      </div>
    </RadioCard>
  </div>
</template>
